import _ from "lodash";
import { SURVEY_FLOW } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        surveyFlow: _.cloneDeep(constants.SURVEY_FLOW),
    }
}

const surveyFlowReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SURVEY_FLOW.SET_SURVEY_FLOW:
            return {
                ...state,
                ui: {
                    ...state.ui,
                    surveyFlow: action.surveyFlow
                }
            }
        default:
            return state
    }
}

export default surveyFlowReducer